import type { SupportedLanguage } from 'types/common.types';
import type { LanguageMessages } from './messages.config';
import en from './messages.en';
import he from './messages.he';

const messages: Record<SupportedLanguage, LanguageMessages> = { en, he };
export default messages;
